import React from 'react'

function error() {
  return (
    <div className='flex justify-center items-center text-3xl text-white'>Error - 404 Not Found</div>
  )
}

export default error